export default class FooterCtaBanner {
    visible = false;
}

document.addEventListener("alpine:init", () => {
    Alpine.data("footerCtaBanner", () => new FooterCtaBanner());
});
